export default function RockBlasterIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none" strokeLinejoin="round" strokeLinecap="round">
      <rect x="2" y="2" width="60" height="60" rx="12" fill="#0b0720" />
      <path d="M36 8l12 3 6 10-3 11-10 4-9-5-2-12z" stroke="#b48cff" strokeWidth="3" fill="#24124a" />
      <path d="M46 42l6 2 2 6-4 4-6-1-2-6z" stroke="#ff7ce6" strokeWidth="3" fill="#3a1238" />
      <g transform="translate(20 42) rotate(-45)">
        <path d="M14 0L-9 -9L-5 0L-9 9Z" stroke="#38f8ff" strokeWidth="3" fill="#0e3a4a" />
        <path d="M-7 -4L-16 0L-7 4" stroke="#ffb02e" strokeWidth="2.5" />
      </g>
      <circle cx="31" cy="31" r="2.2" fill="#fff" />
      <circle cx="26" cy="36" r="1.6" fill="#fff" opacity="0.6" />
    </svg>
  );
}
